import { useRef } from "react";

/**
 * Inspired by `useLatest` from `react-use`.
 * The key difference is that this implementation returns a function,
 * so it can be used inside `useEffect` cleanup function without violating the react-hooks/exhaustive-deps rule.
 *
 * @link https://github.com/streamich/react-use/blob/ad33f76dfff7ddb041a9ef74b80656a94affaa80/src/useLatest.ts
 * @template TValue The type of the value to keep a reference to.
 * @param value The value to keep a reference to.
 * @returns A function that returns the latest value.
 */

export function useLatest<TValue>(value: TValue): () => TValue {
	// it uses a single ref to cut down on the number of hooks
	const ref = useRef({
		value,
		getter: () => ref.current.value,
	});

	ref.current.value = value;

	return ref.current.getter;
}
